import { type Dispatch } from "@reduxjs/toolkit";
import { type FC, useEffect, useState } from "react";
import { connect, type ConnectedProps } from "react-redux";

import { CommunicationSegmentationDropdown } from "../../../../components";
import { ContentTypesEnum, RouteNames } from "../../../../enums";
import { type RootState } from "../../../Application/globaltypes/redux";
import MessagesOverview from "../Messages/Overview/MessagesOverview";
import EmailsOverview from "../Emails/Overview/EmailsOverview";
import { useLocation, useNavigate } from "react-router";

export type CommunicationsOverviewProps = PropsFromRedux;

export const CommunicationsOverview: FC<CommunicationsOverviewProps> = (props) => {
  const location = useLocation();
  const [communicationContext, setCommunicationContext] = useState<string>(
    location.pathname.endsWith("messages") ? ContentTypesEnum.Messages : ContentTypesEnum.Emails,
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname.endsWith(RouteNames.contentCommunications)) {
      navigate(`/${RouteNames.contentCommunications}/${RouteNames.emails}`, { replace: true });
    }
  }, [location.pathname, navigate]);

  const onContentSegmentationChange = (context: string) => {
    setCommunicationContext(context);
    navigate(`/${RouteNames.contentCommunications}/${context.toLowerCase()}`, { replace: true });
  };

  const renderContextSwitcher = (): React.ReactElement => (
    <CommunicationSegmentationDropdown
      onContextChange={onContentSegmentationChange}
      defaultValue={communicationContext as ContentTypesEnum}
    />
  );

  const communicationsListItemsComponents: { [key in string]: React.ReactElement } = {
    Emails: <EmailsOverview customHeaderContent={renderContextSwitcher()} {...props} />,
    Messages: <MessagesOverview customHeaderContent={renderContextSwitcher()} />,
  };

  return communicationsListItemsComponents[communicationContext];
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  return {};
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(CommunicationsOverview);
export default ConnectedComponent;
